import { render, staticRenderFns } from "./authorized-scope.vue?vue&type=template&id=c7d9e76e&scoped=true&"
import script from "./authorized-scope.vue?vue&type=script&lang=js&"
export * from "./authorized-scope.vue?vue&type=script&lang=js&"
import style0 from "./authorized-scope.vue?vue&type=style&index=0&id=c7d9e76e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7d9e76e",
  null
  
)

export default component.exports